import { render, staticRenderFns } from "./WorkflowTestIndex.vue?vue&type=template&id=aedb9066"
import script from "./WorkflowTestIndex.vue?vue&type=script&lang=js"
export * from "./WorkflowTestIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports